import {takeEvery, put, select} from 'redux-saga/effects';
import getInviteABiteInfoApi from 'helpers/services/api/inviteABite';
import {
  GET_INVITE_A_BITE_INFO,
  GET_INVITE_A_BITE_INFO_SUCCESS,
  SET_LOADING
} from 'store/inviteABite/action';

function* getInviteABiteInfo() {
  try {
    yield put(SET_LOADING(true));

    const locationId = yield select((state) => state.user?.activeLocation?._id);

    if (!locationId) {
      yield put(SET_LOADING(false));
      return;
    }

    const {data} = yield getInviteABiteInfoApi(locationId);
    if (data?.data) {
      yield put(GET_INVITE_A_BITE_INFO_SUCCESS(data.data));
    }
    yield put(SET_LOADING(false));
  } catch (error) {
    yield put(SET_LOADING(false));
    console.log('INVITE A BITE SAGA ERROR', error);
  }
}

function* inviteABiteSaga() {
  yield takeEvery(GET_INVITE_A_BITE_INFO, getInviteABiteInfo);
}

export default inviteABiteSaga;
